<template>
  <div class="riskList">
    <div class="table-box">
      <div class="title">
        <div class="icon-box">
          <i class="iconfont icon-xingxing"></i>
        </div>
        <b>机构管理</b>
      </div>
      <div class="tab">
          <span v-for="item in shenTypeOptions"
                :key="item.value"
                :class="{active:item.value == active}"
                class="tab-item" @click="tabChange(item.value)">{{
              item.label
            }}<label v-if="item.key">({{ item.total }})</label></span>
      </div>
      <div class="search-flex">
        <div class="search-box">
          <el-form ref="form" :model="search" class="flex" label-width="100px">
            <el-form-item label="机构名称">
              <el-input v-model="search.org_name" placeholder="请输入机构名称搜索"></el-input>
            </el-form-item>
            <el-form-item label="培训许可证">
              <el-select v-model="search.license" :clearable="true" class="inp" placeholder="请选择">
                <el-option
                  v-for="item in isHave"
                  :key="item.value"
                  :label="item.label"
                  :value="item.value">
                </el-option>
              </el-select>
            </el-form-item>
            <el-form-item label="资金监管账户">
              <el-select v-model="search.jianguan" :clearable="true" class="inp" placeholder="请选择">
                <el-option
                  v-for="item in isYes"
                  :key="item.value"
                  :label="item.label"
                  :value="item.value">
                </el-option>
              </el-select>
            </el-form-item>
            <el-form-item label="状态">
              <el-select v-model="search.is_lock" :clearable="true" class="inp" placeholder="请选择">
                <el-option
                  v-for="item in orgStatusOptionsSearch"
                  :key="item.value"
                  :label="item.label"
                  :value="item.value">
                </el-option>
              </el-select>
            </el-form-item>
            <el-form-item label="培训类型">
              <el-select v-model="search.peixun_lei" :clearable="true" class="inp" placeholder="请选择">
                <el-option
                  v-for="item in peixunTypeOptions"
                  :key="item.value"
                  :label="item.label"
                  :value="item.value">
                </el-option>
              </el-select>
            </el-form-item>
          </el-form>
          <div class="search-btn" @click="searchList">
            <i class="iconfont icon-sousuo"></i>搜索
          </div>
          <div class="search-btn reset" @click="reset">
            <i class="iconfont icon-huanxiang"></i>重置
          </div>
        </div>
        <div class="shensu" @click="downLoad">
          <i class="iconfont icon-fenxiang1"></i>导出
        </div>
      </div>
      <div class="list ">
        <el-table
          v-loading="loading"
          :cell-style="textCenter"
          :data="tableData"
          :header-cell-style="centerbgc"
          border
          style="width: 100%">
          <el-table-column
            label="序号"
            type="index"
            width="80">
          </el-table-column>
          <el-table-column
            label="状态"
            width="100">
            <template slot-scope="scope">
                            <span v-if="scope.row.is_lock == 1" :class="{red:scope.row.is_lock == 2}" class="state">{{
                                scope.row.is_lock | is_lock
                              }}</span>
              <span v-else :class="{red:scope.row.is_lock == 2}" class="state">{{
                  scope.row.reason | reason
                }}</span>
            </template>
          </el-table-column>
          <el-table-column
            label="机构名称"
            prop="org_name"
            width="">
          </el-table-column>
          <el-table-column
            label="商业品牌"
            prop="brand"
            width="200">
          </el-table-column>
          <el-table-column
            label="统一信用代码"
            prop="org_code"
            width="200">
          </el-table-column>
          <el-table-column
            label="经营地址"
            prop="use_address"
            width="350">
          </el-table-column>
          <el-table-column
            label="培训类型"
            prop="peixun_lei"
            width="200">
          </el-table-column>
          <el-table-column
            label="信息更新时间"
            prop="update_time"
            width="200">
          </el-table-column>
          <el-table-column
            label="上次登录时间"
            prop="last_login"
            width="200">
          </el-table-column>
          <el-table-column
            label="操作"
            width="150">
            <template slot-scope="scope" class="flex">
              <el-dropdown v-if="active === 1" @command="handleCommand($event,scope)">
                <el-button type="primary">
                  更多菜单<i class="el-icon-arrow-down el-icon--right"></i>
                </el-button>
                <el-dropdown-menu slot="dropdown">
                  <el-dropdown-item command="1">查看编辑</el-dropdown-item>
                  <el-dropdown-item command="2">{{ scope.row.is_lock == 2 ? '开店' : '闭店' }}
                  </el-dropdown-item>
                  <el-dropdown-item command="5">星级评定</el-dropdown-item>
                  <el-dropdown-item command="4">预警信息</el-dropdown-item>
                  <el-dropdown-item command="3">通知信息</el-dropdown-item>
                </el-dropdown-menu>
              </el-dropdown>
              <el-link v-else type="primary" @click="toApplyItem(scope.row)">审核</el-link>
            </template>
          </el-table-column>
        </el-table>
      </div>

      <div class="page-box">
        <el-pagination
          :current-page.sync="search.page"
          :page-size="search.limit"
          :total="search.total"
          background
          class="page-all margin-top self-end"
          layout="prev, pager, next"
          @current-change="list">
        </el-pagination>
      </div>
    </div>
    <state-tip-dialog :dialog="stateTipDialog" :params="cur_item" :title="cur_title" :title_en="cur_title_en"
                      @watchState="watchState">
      <div slot="content" class="state-tip" v-html="cur_content"></div>
    </state-tip-dialog>
    <state-tip-dialog :dialog="addNoticeDialog" :params="cur_item" confirm-text="确认发布"
                      title="通知信息" title_en="notification message" @watchState="submitNotice">
      <el-input slot="content" v-model="ruleForm.notice" :rows="5" placeholder="请输入通知信息" resize="none"
                type="textarea"></el-input>
    </state-tip-dialog>
  </div>
</template>
<script>
import {
  bidianOptions,
  isHave,
  isYes,
  orgStatusOptions,
  orgStatusOptionsSearch,
  peixunTypeOptions,
  shenTypeOptions
} from "@/utils/const";
import {findByType,frontDownload} from "@/utils/utils";
import {org_export, org_lst, sendOrgMsg, setOrgLock} from "@/api/admin";
import StateTipDialog from "@/views/admin/common/StateTipDialog";
import {fileUrl} from "@/config";

export default {
  name: "riskList",
  data() {
    return {
      fileUrl:fileUrl,
      active: 1,
      shenTypeOptions: shenTypeOptions,
      orgStatusOptionsSearch: orgStatusOptionsSearch,
      isHave: isHave,
      isYes:isYes,
      orgStatusOptions: orgStatusOptions,
      peixunTypeOptions: peixunTypeOptions,
      bidianOptions:bidianOptions,
      dialogVisible: true,
      search: {
        org_name: '',
        license: '',
        jianguan: '',
        is_lock: '',
        peixun_lei: '',
        page: 1,
        limit: 10,
        total: 0,
      },
      tableData: [],
      loading: false,

      cur_item: '',
      cur_content: '',
      cur_title: '',
      cur_title_en: '',
      stateTipDialog: false,
      ruleForm: {
        notice: ''
      },
      addNoticeDialog: false,
    }
  },
  components: {StateTipDialog},
  computed: {
    textCenter() {
      return {
        textAlign: 'center'
      }
    },
    centerbgc() {
      return {
        textAlign: 'center',
        background: '#f7f7f7'
      }
    }
  },
  created() {
    this.$emit("setActive", {
      headActive: 2
    })
    if (this.$route.query.page) {
      this.search.org_name = this.$route.query.org_name
      this.search.license = this.$route.query.license ? Number(this.$route.query.license) : ''
      this.search.jianguan = this.$route.query.jianguan ? Number(this.$route.query.jianguan) : ''
      this.search.is_lock = this.$route.query.is_lock ? Number(this.$route.query.is_lock) : ''
      this.search.peixun_lei = this.$route.query.peixun_lei ? Number(this.$route.query.peixun_lei) : ''
      this.search.page = Number(this.$route.query.page)
    }else {
      if(this.$route.query.license) {
        this.search.license = Number(this.$route.query.license)
      }
      if(this.$route.query.jianguan) {
        this.search.jianguan = Number(this.$route.query.jianguan)
      }
    }

    this.list()
  },
  methods: {
    async list() {
      this.loading = true;
      let _data = await org_lst(
        this.search.org_name,
        this.search.license,
        this.search.jianguan,
        this.search.is_lock,
        this.search.peixun_lei,
        this.active,
        this.search.page,
        this.search.limit
      );
      this.loading = false;
      if (_data.status == 200) {
        this.tableData = _data.data.data
        this.search.total = _data.data.total
        this.shenTypeOptions.map(item => {
          if (item.key) item.total = _data.data[item.key]
        })
      } else {
        this.$message.error(_data.msg)
      }
    },

    async downLoad(){
      let _data = await org_export(
        this.search.org_name,
        this.search.license,
        this.search.jianguan,
        this.search.is_lock,
        this.search.peixun_lei,
        this.active
      );
      if (_data.status == 200) {
        let url = this.fileUrl + _data.data.path
        frontDownload(url)
      } else {
        this.$message.error(_data.msg)
      }
    },


    handleCommand(command, scope) {
      switch (command) {
        case "1":
          this.$router.push({
            path: '/admin/orgDetail',
            query: {
              org_id: scope.row.id,
              org_name: this.search.org_name,
              license: this.search.license,
              jianguan: this.search.jianguan,
              is_lock: this.search.is_lock,
              peixun_lei: this.search.peixun_lei,
              active: this.active,
              page: this.search.page,
            }
          })
          break;
        case "2":
          this.cur_item = scope.row
          this.cur_title = scope.row.is_lock == 2 ? ' 开店通知' : ' 闭店通知'
          this.cur_title_en = scope.row.is_lock == 2 ? 'Opening Notice' : 'Closure Notice'
          this.cur_content = scope.row.is_lock == 2 ? '确认开店后，此教培机构账号可正常使用所有功能，请确认是否要开店，<span class="red">请谨慎操作</span>。' : '确认闭店后，此教培机构账号不可再登录，不可正常使用现有功能，请问是否要确认闭店，<span class="red">请谨慎操作</span>。'
          this.stateTipDialog = true
          break;
        case "3":
          this.cur_item = scope.row
          this.ruleForm.notice = ''
          this.addNoticeDialog = true
          break;
        case "4":
          this.$router.push(`/admin/riskList?keyword=${scope.row.org_name}`)
          break;
        case "5":
          this.$router.push(`/admin/orgEvaluate?oid=${scope.row.id}`)
          break;
      }
    },
    async watchState(data, yuanyin) {
      if (data) {
        let _data = await setOrgLock(data.id, data.is_lock == 2 ? 1 : 2, yuanyin)
        if (_data.status == 200) {
          this.$message.success('操作成功')
          this.list()
        } else {
          this.$message.error(_data.msg)
        }
      }
      this.stateTipDialog = false
    },
    async submitNotice(data) {
      if (data) {
        if (!this.ruleForm.notice) return this.$message.error('请输入通知信息')
        let _data = await sendOrgMsg(data.id, this.ruleForm.notice)
        if (_data.status == 200) {
          this.$message.success('操作成功')
          this.list()
        } else {
          this.$message.error(_data.msg)
        }
      }
      this.addNoticeDialog = false
    },

    toApplyItem(item) {
      this.$router.push({
        path: '/admin/orgApply',
        query: {
          org_id: item.id
        }
      })
    },
    searchList() {
      this.search.page = 1
      this.list()
    },
    reset() {
      this.search = {
        org_name: '',
        license: '',
        is_lock: '',
        peixun_lei: '',
        page: 1,
      }
      this.list()
    },
    tabChange(value) {
      this.active = value
      this.searchList()
    }
  },
  watch: {},
  filters: {
    is_lock(val) {
      return findByType(orgStatusOptions, val)
    },
    reason(val) {
      return findByType(bidianOptions, val)
    },
  }
}
</script>

<style lang="scss" scoped>

.state {
  color: #75c773;

  &.red {
    color: #f61919;
  }
}

.riskList {
  width: 100%;
  height: 100%;
  min-height: calc(100vh - (173px + 159px));
  background: #f3f5f7;
  padding: 20px;

  .table-box {
    width: 100%;
    background-image: linear-gradient(0deg,
      #ffffff 84%,
      #edf6ff 100%);
    padding: 0 20px;
    border-radius: 10px;
    min-height: 500px;

    .tab {
      width: 100%;
      display: flex;
      justify-content: flex-start;
      align-items: center;
      border-bottom: solid 2px #e3e7f0;

      span {
        width: max-content;
        margin-left: 45px;
        height: 60px;
        line-height: 60px;
        font-size: 18px;
        color: #63686e;
        margin-right: 20px;
        cursor: pointer;

        &.active {
          color: #2791ff;
          font-weight: bold;
          border-radius: 2px;
          border-bottom: solid 4px #2791ff;
        }
      }
    }

    .title {
      display: flex;
      justify-content: flex-start;
      align-items: center;
      padding-top: 25px;
      //height: 60px;
      //border-bottom: 2px solid #e3e7f0;
      b {
        font-size: 22px;
        color: #16181d;
        font-weight: bold;
        margin-left: 10px;
      }

      .icon-box {
        width: 30px;
        height: 30px;
        background-image: linear-gradient(-30deg,
          #3579fb 0%,
          #44a3ff 100%);
        box-shadow: 0px 10px 10px 0px rgba(50, 150, 255, 0.3);
        border-radius: 10px;
        text-align: center;
        line-height: 30px;

        i {
          font-size: 20px;
          color: #ffffff;
        }
      }
    }

    .list {
      width: 100%;
      min-height: calc(100vh - (173px + 159px + 350px));

      .btn {
        width: 60px;
        height: 26px;
        border-radius: 4px;
        font-size: 14px;
        text-align: center;
        line-height: 26px;
        margin: 0 auto;

        &.gray {
          color: #8a8a8a;
          background-color: #f2f2f2;
        }

        &.yellow {
          color: #fad471;
          background-color: #fffbdd;
        }

        &.orange {
          color: #f58739;
          background-color: #ffeedd;
        }

        &.red {
          color: #f8001a;
          background-color: #ffdddd;
        }
      }
    }

    .search-flex {
      width: 100%;
      display: flex;
      justify-content: space-between;
      align-items: center;

      padding: 20px 0;

      .shensu {
        width: 113px;
        height: 37px;
        background-image: linear-gradient(0deg,
          #f59a23 0%,
          #feb555 100%);
        border-radius: 4px;
        text-align: center;
        line-height: 37px;
        font-size: 16px;
        color: #ffffff;
        cursor: pointer;

        i {
          font-size: 20px;
          margin-right: 5px;
          color: #ffffff;
        }
      }

      .search-box {
        display: flex;
        justify-content: flex-start;
        align-items: center;

        .search-btn {
          width: 112px;
          height: 36px;
          background-image: linear-gradient(0deg,
            #2791ff 0%,
            #81b6ff 100%);
          border-radius: 4px;
          text-align: center;
          line-height: 36px;
          font-size: 16px;
          color: #ffffff;
          margin-left: 15px;
          cursor: pointer;

          i {
            font-size: 20px;
            margin-right: 5px;
            color: #ffffff;
          }

          &.reset {
            background-image: none;
            background-color: #ffffff;
            border-radius: 4px;
            border: solid 1px #cccccc;
            line-height: 34px;
            color: #333333;

            i {
              color: #999999;
            }
          }
        }
      }

    }
  }

}
</style>


